import VueGtm from '@gtm-support/vue2-gtm'

export default async ({ router, Vue }) => {
	if (process.env.ID_GTM && process.env.AUTH_GTM && process.env.PREVIEW_GTM) {
		Vue.use(VueGtm, {
			id: process.env.ID_GTM,
			queryParams: {
				gtm_auth: process.env.AUTH_GTM, 
				gtm_preview: process.env.PREVIEW_GTM,
				gtm_cookies_win: 'x'
			},
			defer: true,
			compatibility: false,
			nonce: '2726c7f26c',
			enabled: true,
			debug: true,
			loadScript: true,
			vueRouter: router,
			ignoredViews: [],
			trackOnNextTick: false
		})
	}

	Vue.prototype.$hasGtm = process.env.ID_GTM && process.env.AUTH_GTM && process.env.PREVIEW_GTM
 	? true : false
}


